import React, { useEffect, useState } from "react";
import SignaturePad from "../../components/signature/signaturePad";
interface ValidationPrestaProps {
    signature?: string;
    inputKey: string;
    onUpdate: any;
    readOnly: boolean;
}
const ValidationPresta: React.FC<ValidationPrestaProps> = ({ signature, inputKey, onUpdate, readOnly
}) => {
    const [isSigned, setIsSigned] = useState<boolean>(!!signature);
    useEffect(() => {
        if (signature !== "" && signature !== undefined) {
            setIsSigned(true)
        }
    }, [signature])
    const [clear, setClear] = useState<boolean>(false);
    const [consent, setConsent] = useState<boolean>(false);
    const [signatureBase64, setSignatureBase64] = useState("")
    const handleSignature = (sig: string) => {
        const signatureHex = (sig);
        if (onUpdate) {
            onUpdate(inputKey, signatureHex);
        }
        setIsSigned(true);
        setClear(false);
    };
    const clearSignature = () => {
        if (!readOnly) {
            setIsSigned(false);
            setClear(true);
            setSignatureBase64("");
        }
        onUpdate(inputKey, '');
    };

    useEffect(() => {
        if (signature) {
            setSignatureBase64((signature))
        }
    }, [signature])

    return (
        <div className="validationPresta">
            <h4>Signature :</h4>
            <SignaturePad
                key={isSigned ? "signed" : clear ? "cleared" : "empty"}
                readOnly={readOnly}
                onSignature={handleSignature}
                signature={signature}
                clear={clear}
                isSigned={isSigned}
                consent={consent}
                setConsent={setConsent}
            />
            {isSigned && signatureBase64 && (
                <button onClick={clearSignature} aria-label="Clear Signature" style={{ background: 'none', border: 'none', padding: 0 }}>
                    <img className="imgSignature" src={`data:image/png;base64,${signatureBase64}`} alt="Signature" />
                </button>
            )}
        </div>
    );
};
export default ValidationPresta;
